import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { DownloadCategory, DownloadCloud } from "../download";
import { DownloadDtoSchema } from "../dto";

export const listDownloads = {
  name: "listDownloads" as const,
  input: z.object({
    limit: z.number().optional(),
    reportTypes: z.array(z.string()).max(20).optional(),
    cloud: createEnum(DownloadCloud, { enumName: "DownloadCloud" }).optional(),
    category: createEnum(DownloadCategory, {
      enumName: "DownloadCategory",
    }).optional(),
  }),
  output: z.object({ downloads: z.array(DownloadDtoSchema) }),
};
